<script>
import { Doughnut, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins
// const brandPrimary = '#20a8d8'
export default {
  extends: Doughnut,
  mixins: [reactiveProp],
  props: ['options', 'chartData', 'height'],
  mounted () {
    console.log('Doughnut Chart vue mounted')
    this.renderChart(this.chartData, this.options)
  }
}
</script>
